(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["featured-videos"] && !Shopify.designMode) return;
  try {
    const updateFeaturedVideosControls = (slider) => {
    const viewport = slider.querySelector('.featured-videos__viewport');
    const track = slider.querySelector('.featured-videos__track');

    if (!viewport || !track) return;

    const canScroll = track.scrollWidth > track.clientWidth + 1;

    viewport.classList.toggle('featured-videos__viewport--no-scroll', !canScroll);
  };

  const updateAllFeaturedVideosControls = () => {
    document.querySelectorAll('.featured-videos').forEach(updateFeaturedVideosControls);
  };

  document.addEventListener('DOMContentLoaded', updateAllFeaturedVideosControls);
  window.addEventListener('resize', updateAllFeaturedVideosControls);
  updateAllFeaturedVideosControls();

  document.addEventListener('click', (event) => {
    const toggleButton = event.target.closest('[data-featured-video-toggle]');

    if (toggleButton) {
      const media = toggleButton.closest('.featured-videos__media');
      const video = media?.querySelector('video');

      if (!media || !video) return;

      const shouldPlay = video.paused;

      document.querySelectorAll('.featured-videos__media.is-playing').forEach((item) => {
        if (item === media) return;

        const itemVideo = item.querySelector('video');
        const itemButton = item.querySelector('[data-featured-video-toggle]');

        itemVideo?.pause();
        item.classList.remove('is-playing');
        itemButton?.setAttribute('aria-pressed', 'false');
        itemButton?.setAttribute('aria-label', 'Play video');
      });

      if (shouldPlay) {
        video.play();
        media.classList.add('is-playing');
        toggleButton.setAttribute('aria-pressed', 'true');
        toggleButton.setAttribute('aria-label', 'Pause video');
      } else {
        video.pause();
        media.classList.remove('is-playing');
        toggleButton.setAttribute('aria-pressed', 'false');
        toggleButton.setAttribute('aria-label', 'Play video');
      }

      return;
    }

    const previousButton = event.target.closest('[data-featured-videos-previous]');
    const nextButton = event.target.closest('[data-featured-videos-next]');

    if (!previousButton && !nextButton) return;

    const slider = event.target.closest('.featured-videos');
    const track = slider?.querySelector('.featured-videos__track');
    const slide = track?.querySelector('.featured-videos__slide');

    if (!track || !slide) return;

    const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    const distance = slide.getBoundingClientRect().width + gap;

    track.scrollBy({
      left: nextButton ? distance : -distance,
      behavior: 'smooth',
    });

    window.setTimeout(() => updateFeaturedVideosControls(slider), 350);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["size-guide"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const tab = event.target.closest('.size-guide-block__tab');

    if (!tab) return;

    const dialog = tab.closest('.size-guide-block__dialog');

    if (!dialog) return;

    const tabs = Array.from(dialog.querySelectorAll('.size-guide-block__tab'));
    const heroPanels = Array.from(dialog.querySelectorAll('.size-guide-block__hero-panel'));
    const panels = Array.from(dialog.querySelectorAll('.size-guide-block__panel'));

    tabs.forEach((item) => {
      const isSelected = item === tab;
      item.setAttribute('aria-selected', isSelected ? 'true' : 'false');
      item.tabIndex = isSelected ? 0 : -1;
    });

    panels.forEach((panel) => {
      panel.hidden = panel.id !== tab.getAttribute('aria-controls');
    });

    heroPanels.forEach((panel) => {
      panel.hidden = panel.id !== tab.dataset.heroId;
    });
  });

  document.addEventListener('keydown', (event) => {
    const tab = event.target.closest('.size-guide-block__tab');

    if (!tab || (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight')) return;

    const tabs = Array.from(tab.closest('.size-guide-block__tabs').querySelectorAll('.size-guide-block__tab'));
    const currentIndex = tabs.indexOf(tab);
    const direction = event.key === 'ArrowRight' ? 1 : -1;
    const nextIndex = (currentIndex + direction + tabs.length) % tabs.length;

    event.preventDefault();
    tabs[nextIndex].focus();
    tabs[nextIndex].click();
  });
  } catch(e) { console.error(e); }
})();

})();
